<script lang="ts" context="module">
  import { map, Observable, delay, tap, shareReplay } from "rxjs";

  import { fetchProduct } from "$lib/serv/groc-product";
  import type { ProductData } from "$lib/def/landing";
  import { RxWritable } from "$lib/util/obs";

  class State {
    products: ProductData[] = [];
		loading = false;
		errorCode = 0;

    constructor(products: ProductData[] = [], loading = false, errorCode = 0) {
      this.products = products;
      this.loading = loading;
      this.errorCode = errorCode;
    }
  }
  const state$ = new RxWritable(new State());

  export const showPDP$: Observable<boolean> = state$.pipe(
    map(({ products, loading, errorCode }) => products.length > 0 || loading || errorCode !== 0),
    shareReplay(1),
  );

  export const product$: Observable<ProductData | null> = state$.pipe(
    map(({ products: ps }) => (ps.length ? ps[ps.length - 1] : null)),
  );

  function remove() {
    state$.update((s) => {
      const ps = s.products;
      if (ps.length === 1) return new State();
      ps.splice(ps.length - 1, 1);
      return new State(ps);
    });
  }

  function loadProduct(catalogue_key: string) {
    // console.log("FETCHING PRODUCT");
    state$.update((s) => new State(s.products, true));
    fetchProduct(catalogue_key)
      // .pipe(delay(1000))
      .subscribe({
        next: (p) => {
          // console.log("GOT PRODUCT", p);
          state$.update((s) => new State([...s.products, {...p, pristine: true}]));
        },
        error: (e) => {
          // console.log("FALIED TO GET PRODUCT", e);
          state$.update((s) => new State(s.products, false, e.http_response_code));
        },
        // complete: () => console.log("COMPLETE LOAD PRODUCT"),
      });
  }

  export function showDetail(product: ProductData | string | null) {
    if (typeof product === "string") return loadProduct(product);

    state$.update((s) =>
      product != null ? new State([...s.products, {...product, pristine: true}]) : new State());
  }

  export function setBackup(product: ProductData | null) {
    state$.update((s) => {
      const ps = s.products;
      const p = ps[ps.length - 1];
      p.alternative_item = product;
      p.pristine = false;
      return new State(ps);
    });
  }
</script>

<script lang="ts">
  import { query } from "$lib/util/url";
  import Loading from "./Loading.svelte";
  import Error from "./Error.svelte";
  import Detail from "./Detail.svelte";

  // const logState$ = state$.pipe(
  //   tap((state) => console.log('PDP state', state)),
  // );
  // $logState$;
  const product$$ = product$.pipe(
    tap((p) => {
      const { search } = window.location;
      if (p != null) query(search).set("catalogue_key", p.catalogue_key).go({ noScroll: true });
      else query(search).remove("catalogue_key").go({ noScroll: true });
    })
  );
  $product$$;
</script>

{#if $state$.loading}
  <Loading />
{:else if $state$.errorCode}
  <Error errorCode={$state$.errorCode} />
{:else if $product$}
  <Detail
    product={$product$}
    on:detail={(e) => showDetail(e.detail)}
    on:close={() => showDetail(null)}
    on:back={remove}
    on:backup={(e) => setBackup(e.detail)}
    on:showBackupModal
  />
{/if}
